import { useState } from "react";
import { motion } from "framer-motion";
import { Eyebrow, MaskLines, Reveal } from "./Reveal";
import { SERVICES } from "./data";

const ServiceCard = ({ s, i }) => (
  <motion.article
    key={s.title}
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay: i * 0.08 }}
    data-testid={`service-card-${i}`}
    className={`group relative flex min-h-[260px] flex-col justify-end overflow-hidden border border-white/10 bg-[#12161F] p-7 transition-colors duration-500 hover:border-blue-500/70 ${s.wide ? "md:col-span-12" : i === 0 || i === 3 || i === 5 ? "md:col-span-7" : "md:col-span-5"}`}
  >
    {s.img && (
      <div className="absolute inset-0 grid" style={{ gridTemplateColumns: s.img6 ? "1fr 1fr 1fr" : s.img5 || s.img4 ? "1fr 1fr" : s.img3 ? "1fr 1fr 1fr" : s.img2 ? "1fr 1fr" : "1fr" }}>
        {[s.img, s.img2, s.img3, s.img4, s.img5, s.img6, s.img7].filter(Boolean).map((src, i) => (
          <img key={src} src={src} alt="" className={`h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105 ${i === 0 ? "block" : "hidden sm:block"}`} style={s.img6 && i === 6 ? { gridColumn: "span 3" } : undefined} />
        ))}
      </div>
    )}
    {s.img && <span className="absolute inset-0 bg-gradient-to-t from-[#0D1015] via-[#0D1015]/70 to-[#0D1015]/30" />}
    <span className={`absolute inset-x-0 bottom-0 h-0 bg-blue-600 transition-[height] duration-500 ease-out group-hover:h-1 ${s.img ? "z-10" : ""}`} />
    <div className={`relative flex items-start justify-between ${s.img ? "z-10" : ""}`}>
      <span className="font-mono text-xs tracking-[0.2em] text-blue-400">{s.k}</span>
      <span className={`font-display text-7xl font-black leading-none transition-colors duration-500 ${s.img ? "text-white/40" : "text-white/5 group-hover:text-blue-500/25"}`}>0{i + 1}</span>
    </div>
    <div className={`relative ${s.img ? "z-10" : ""}`}>
      <h3 className="font-display text-3xl font-bold uppercase text-white sm:text-4xl">{s.title}</h3>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-300 sm:text-base">{s.text}</p>
      <div className="mt-5 flex flex-wrap gap-2">
        {s.tags.map((t) => (
          <span key={t} className="border border-white/15 bg-black/40 px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider text-slate-200">{t}</span>
        ))}
      </div>
    </div>
  </motion.article>
);

export const Services = () => {
  const [tab, setTab] = useState("residential");
  return (
    <section id="services" data-testid="services-section" className="bg-[#090B0E] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <div className="mb-14 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div>
            <Eyebrow>What we build</Eyebrow>
            <h2 className="font-display text-5xl font-black uppercase leading-[0.9] text-white sm:text-6xl lg:text-7xl">
              <MaskLines inView lines={["Two sectors.", "One standard."]} />
            </h2>
          </div>
          <Reveal className="flex border border-white/15 p-1">
            {["residential", "commercial"].map((t) => (
              <button
                key={t}
                data-testid={`service-tab-${t}`}
                onClick={() => setTab(t)}
                className={`relative px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] transition-colors sm:px-7 ${tab === t ? "text-white" : "text-slate-300 hover:text-white"}`}
              >
                {tab === t && <motion.span layoutId="tab-bg" className="absolute inset-0 bg-blue-700" transition={{ type: "spring", stiffness: 300, damping: 30 }} />}
                <span className="relative">{t}</span>
              </button>
            ))}
          </Reveal>
        </div>
        <div key={tab} className="grid gap-4 md:grid-cols-12">
          {SERVICES[tab].map((s, i) => <ServiceCard key={s.title} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
};
